/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'group': {
    width: 24,
    height: 24,
    viewBox: '0 0 512 512',
    data: '<path d="M113.8 284.4c31.4 0 56.9-25.5 56.9-56.9s-25.5-56.9-56.9-56.9-56.9 25.5-56.9 56.9c.1 31.4 25.5 56.9 56.9 56.9zm32.1 31.3c-10.6-1.8-21.4-2.8-32.1-2.8-27.2 0-54.1 5.6-79.1 16.5C13.6 338.4 0 359.1 0 382v44.7h128v-45.8c0-23 6.2-45.5 17.9-65.2zm316-12.8c-38-16.9-79.1-25.6-120.6-25.6-41.5.1-82.6 8.9-120.6 25.6-30.6 13.8-50.3 44.3-50.1 77.9v45.8H512v-45.8c.2-33.5-19.4-64.1-50.1-77.9zm-232.3 66.9c2.6-6.5 3.7-11.1 25.9-19.5 55.3-21.2 116.5-21.2 171.8 0 21.9 8.5 23 13 25.9 19.5H229.6zm111.7-227.6c15.7 0 28.4 12.7 28.4 28.4S357 199 341.3 199s-28.4-12.7-28.4-28.4c0-15.6 12.7-28.3 28.4-28.4m0-56.9c-47.1 0-85.3 38.2-85.3 85.3 0 47.1 38.2 85.3 85.3 85.3s85.3-38.2 85.3-85.3c.1-47.1-38-85.3-85.1-85.3h-.2z"></path>'
  }
})
